import useSWR from 'swr';

export const useOrganization = (id) => useSWR(id ? `organizations/${id}` : null);
